// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b6913e48","147":"5961d603","210":"ce82df63","362":"edc7c8d4","429":"c1f0efab","807":"a7117d3a","899":"2782c273","900":"bbec8e99","996":"b3d8b595"}[chunkId] + ".chunk.js";
};